import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 数据概览总计
interface HeadStatisticsData {
  token: string;
  type: number;
  start_time: any;
  end_time: any;
  game_id: string;
  server_id: string;
}

export const headStatistics = (json: HeadStatisticsData): any =>
  http.httpPost({
    url: httpApi.dataIndex.headStatistics,
    json,
  });

// 数据概览图表数据

export const statistics = (json: HeadStatisticsData): any =>
  http.httpPost({
    url: httpApi.dataIndex.statistics,
    json,
  });

// 交易币分析头部数据
interface HeadAnalysisData {
  token: string;
  type: number;
  game_id: string;
  server_id: string;
  start_time: any;
  end_time: any;
  device_type: string;
  compare_start_time: string;
  compare_end_time: string;
}

export const headAnalysis = (json: HeadAnalysisData): any =>
  http.httpPost({
    url: httpApi.dataIndex.headAnalysis,
    json,
  });

// 交易币分析尾部数据
export const currencyAnalysis = (json: HeadAnalysisData): any =>
  http.httpPost({
    url: httpApi.dataIndex.currencyAnalysis,
    json,
  });

// 交易币分析底部表格数据
interface CurrencyViewData {
  token: string;
  start_time: any;
  end_time: any;
}

export const currencyView = (json: CurrencyViewData): any =>
  http.httpPost({
    url: httpApi.dataIndex.currencyView,
    json,
  });

// 砍价数据分析
interface BargainAnalysisData {
  token: string;
  begin_time: string;
  end_time: string;
  device: string;
}

export const bargainAnalysis = (json: BargainAnalysisData): any =>
  http.httpPost({
    url: httpApi.dataIndex.bargainAnalysis,
    json,
  });

// 获取砍价配置列表
interface BargainConfigData {
  token: string;
}

export const bargainConfig = (json: BargainConfigData): any =>
  http.httpPost({
    url: httpApi.dataIndex.bargainConfig,
    json,
  });

// 修改砍价配置列表
interface SaveBargainData {
  token: string;
  id: string;
  bond: string;
  counter_offer: string;
  payment_time: string;
  seller_cancel_time: string;
  counter_rate: string;
  attention: string;
  bond_description: string;
  commodity_bargain_num: string;
  seller_agree_bargain_txt: string;
  seller_cancel_bargain_txt: string;
}

export const saveBargain = (json: SaveBargainData): any =>
  http.httpPost({
    url: httpApi.dataIndex.saveBargain,
    json,
  });

// 数据分析头部 - 贾琳
interface DataAnalysisHeadData {
  date_type: number;
  start_time: string;
  end_time: string;
  contrast: number;
  contrast_start_time: string;
  contrast_end_time: string;
  type: number;
}

export const dataAnalysisHead = (json: DataAnalysisHeadData): any =>
  http.httpPost({
    url: httpApi.dataIndex.dataAnalysisHead,
    json,
  });
export const extractDataAnalysisHead = (json: DataAnalysisHeadData): any =>
  http.httpPost({
    url: httpApi.dataIndex.extractDataAnalysisHead,
    json,
  });
export const marginDataAnalysisHead = (json: DataAnalysisHeadData): any =>
  http.httpGet({
    url: httpApi.dataIndex.marginDataAnalysisHead,
    json,
  });

// 数据分析尾部 - 贾琳
interface DataAnalysisEndData {
  token: string;
  date_type: number;
  start_time: string;
  end_time: string;
  export?: number;
  page: number;
  size: number;
}

export const dataAnalysisEnd = (json: DataAnalysisEndData): any =>
  http.httpGet({
    url: httpApi.dataIndex.dataAnalysisEnd,
    json,
  });
export const extractDataAnalysisEnd = (json: DataAnalysisEndData): any =>
  http.httpGet({
    url: httpApi.dataIndex.extractDataAnalysisEnd,
    json,
  });
export const marginDataAnalysisEnd = (json: DataAnalysisEndData): any =>
  http.httpGet({
    url: httpApi.dataIndex.marginDataAnalysisEnd,
    json,
  });

// 游戏分析头部 - 贾琳
interface GameAnalysisHeadData {
  date_type: number;
  game_id: string;
  start_time: string;
  end_time: string;
  contrast: number;
  contrast_start_time: string;
  contrast_end_time: string;
  type: number;
}

export const gameAnalysisHead = (json: GameAnalysisHeadData): any =>
  http.httpPost({
    url: httpApi.dataIndex.gameAnalysisHead,
    json,
  });

// 游戏分析尾部 - 贾琳
interface GameAnalysisEndData {
  token: string;
  field?: string;
  sort?: string;
  game_id: string;
  date_type: number;
  start_time: string;
  end_time: string;
  export?: number;
  page: number;
  size: number;
}

export const gameAnalysisEnd = (json: GameAnalysisEndData): any =>
  http.httpGet({
    url: httpApi.dataIndex.gameAnalysisEnd,
    json,
  });

// 砍价列表 - 贾琳
interface BargainListParams {
  token: string;
  game_id: string;
  user_id: string;
  user_account: string;
  seller_user_id: string;
  commodity_id: string;
  status: string;
  s_time: string;
  e_time: string;
  field_str: string;
  page: number;
  size: number;
  export?: number;
}

export const bargainList = (json: BargainListParams): any =>
  http.httpGet({
    url: httpApi.dataIndex.bargainList,
    json,
  });
